<template>
  <div class="project-info">
    <head>
      <title>{{ $i18n.locale === "ar" ? data.name_ar : data.name_en }}</title>
    </head>
    <div class="container py-5 hidden" v-in-view="'animate__slideInRight'">
      <div
        class="bg-whitesmoke py-5 d-flex justify-content-cenetr align-items-center"
        style="flex-direction: column"
      >
        <div class="row w-100 p-3 my-3" v-if="$store.state.token != ''">
          <div class="col-lg-3 mb-2 col-6">
            <button
              class="btn btn-outline-warning w-100 text-dark p-2"
              @click="page_type = 0"
            >
              {{ $t("ProjectInfo") }}
            </button>
          </div>
          <div class="col-lg-3 mb-2 col-6">
            <button
              class="btn btn-outline-warning w-100 text-dark p-2"
              @click="page_type = 1"
            >
              {{ $t("expenses") }}
            </button>
          </div>
          <div class="col-lg-3 mb-2 col-6">
            <button
              class="btn btn-outline-warning w-100 text-dark p-2"
              @click="page_type = 2"
            >
              {{ $t("Certificates") }}
            </button>
          </div>
          <div class="col-lg-3 mb-2 col-6">
            <button
              class="btn btn-outline-warning w-100 text-dark p-2"
              @click="page_type = 3"
            >
              {{ $t("Live") }}
            </button>
          </div>
        </div>

        <div class="grid-2" v-if="page_type == 0">
          <div class="photos-videos">
            <div class="abs-buttons">
              <div
                class="photos btn-style"
                :style="{ color: type == 'photo' ? '#c39a3e' : '' }"
                @click="type = 'photo'"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="currentColor"
                    d="M18 8a2 2 0 1 1-4 0a2 2 0 0 1 4 0"
                  />
                  <path
                    fill="currentColor"
                    fill-rule="evenodd"
                    d="M11.943 1.25h.114c2.309 0 4.118 0 5.53.19c1.444.194 2.584.6 3.479 1.494c.895.895 1.3 2.035 1.494 3.48c.19 1.411.19 3.22.19 5.529v.088c0 1.909 0 3.471-.104 4.743c-.104 1.28-.317 2.347-.795 3.235c-.21.391-.47.742-.785 1.057c-.895.895-2.035 1.3-3.48 1.494c-1.411.19-3.22.19-5.529.19h-.114c-2.309 0-4.118 0-5.53-.19c-1.444-.194-2.584-.6-3.479-1.494c-.793-.793-1.203-1.78-1.42-3.006c-.215-1.203-.254-2.7-.262-4.558c-.002-.473-.002-.973-.002-1.501v-.058c0-2.309 0-4.118.19-5.53c.194-1.444.6-2.584 1.494-3.479c.895-.895 2.035-1.3 3.48-1.494c1.411-.19 3.22-.19 5.529-.19m-5.33 1.676c-1.278.172-2.049.5-2.618 1.069c-.57.57-.897 1.34-1.069 2.619c-.174 1.3-.176 3.008-.176 5.386v.844l1.001-.876a2.3 2.3 0 0 1 3.141.104l4.29 4.29a2 2 0 0 0 2.564.222l.298-.21a3 3 0 0 1 3.732.225l2.83 2.547c.286-.598.455-1.384.545-2.493c.098-1.205.099-2.707.099-4.653c0-2.378-.002-4.086-.176-5.386c-.172-1.279-.5-2.05-1.069-2.62c-.57-.569-1.34-.896-2.619-1.068c-1.3-.174-3.008-.176-5.386-.176s-4.086.002-5.386.176"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>
              <div
                v-if="videoSrc != null"
                class="videos btn-style"
                :style="{ color: type == 'video' ? '#c39a3e' : '' }"
                @click="type = 'video'"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 256 256"
                >
                  <path
                    fill="currentColor"
                    d="m164.44 105.34l-48-32A8 8 0 0 0 104 80v64a8 8 0 0 0 12.44 6.66l48-32a8 8 0 0 0 0-13.32M120 129.05V95l25.58 17ZM216 40H40a16 16 0 0 0-16 16v112a16 16 0 0 0 16 16h176a16 16 0 0 0 16-16V56a16 16 0 0 0-16-16m0 128H40V56h176zm16 40a8 8 0 0 1-8 8H32a8 8 0 0 1 0-16h192a8 8 0 0 1 8 8"
                  />
                </svg>
              </div>
            </div>
            <div class="myimgs-container" v-if="type == 'photo'">
              <div class="my-img-container">
                <img
                  :src="$store.state.server_images + src"
                  alt=""
                  clsas="img-bg-news"
                  :style="{
                    height: 'fit-content',
                    width: ScreenWidth <= 1025 ? '250px' : '500px',
                  }"
                />
                <div class="show-hide" @click="openPopup(selectedIndex)">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="30"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fill="white"
                      d="M16 0H9.5L12 2.5l-3 3L10.5 7l3-3L16 6.5zm0 16V9.5L13.5 12l-3-3L9 10.5l3 3L9.5 16zM0 16h6.5L4 13.5l3-3L5.5 9l-3 3L0 9.5zM0 0v6.5L2.5 4l3 3L7 5.5l-3-3L6.5 0z"
                    />
                  </svg>
                </div>
              </div>
              <!-- img changer -->
              <div class="grid-3">
                <img
                  class="imgs"
                  :src="$store.state.server_images + data.image"
                  alt=""
                  clsas="img-bg-news"
                  @click="
                    src = data.image;
                    openPopup(0);
                  "
                />
                <img
                  class="imgs"
                  v-for="(item, index) in data.images"
                  :key="index"
                  :src="$store.state.server_images + item.image"
                  alt=""
                  clsas="img-bg-news"
                  @click="
                    src = item.image;
                    openPopup(parseInt(index) + 1);
                  "
                />
              </div>
            </div>
            <div class="myvideo-container" v-if="type == 'video'">
              <div class="my-vide-container">
                <video
                  class="my-video"
                  controls
                  @contextmenu.prevent
                  controlsList="nodownload"
                >
                  <source
                    :src="$store.state.server_images + videoSrc"
                    type="video/mp4"
                  />
                  Your browser does not support HTML5 video.
                </video>
                <div class="grid-3">
                  <div
                    class="video-card"
                    v-for="(item, index) in data.videos"
                    :key="index"
                    @click="ChangeVideo(item.video)"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="50"
                      height="50"
                      viewBox="0 0 24 24"
                    >
                      <g fill="none" stroke="white">
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M16.211 11.106L9.737 7.868A1.2 1.2 0 0 0 8 8.942v6.116a1.2 1.2 0 0 0 1.737 1.074l6.474-3.238a1 1 0 0 0 0-1.788"
                        />
                        <circle cx="12" cy="12" r="9" />
                      </g>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="content my-3 text-center"
            :class="
              $i18n.locale === 'ar'
                ? 'me-lg-5 text-lg-end'
                : 'ms-lg-5 text-lg-start'
            "
          >
            <h1>{{ $i18n.locale === "ar" ? data.name_ar : data.name_en }}</h1>
            <h4 style="color: #c39a3e" class="my-4">
              {{ $t("ProjctType") }}
              <span class="text-dark">{{
                $i18n.locale === "ar" ? type_arr.name_ar : type_arr.name_en
              }}</span>
            </h4>
            <h4 style="color: #c39a3e">{{ $t("ProjctServices") }}</h4>
            <div class="row">
              <div
                class="col-lg-4"
                style="text-align: center; font-weight: 700; font-size: 18px"
                v-for="(item, index) in services"
                :key="index"
              >
                <Icon :icon="item.icon" width="35" highet="35" />
                {{ $i18n.locale === "ar" ? item.name_ar : item.name_en }}
              </div>
            </div>
            <div
              class="desc-container my-4"
              v-if="$i18n.locale === 'ar' && description_ar.length > 0"
            >
              <div
                class="content-desc"
                v-for="(item, index) in description_ar"
                :key="index"
              >
                <h2 class="my-2">
                  {{ item.title_ar }}
                </h2>
                <h4 class="my-2">
                  {{ item.description_ar }}
                </h4>
              </div>
            </div>
            <div
              class="desc-container my-4"
              v-else-if="$i18n.locale === 'en' && description_en.length > 0"
            >
              <div
                class="content-desc"
                v-for="(item, index) in description_en"
                :key="index"
              >
                <h2 class="my-2">
                  {{ item.title_en }}
                </h2>
                <h4 class="my-2">
                  {{ item.description_en }}
                </h4>
              </div>
            </div>
            <h4 class="my-4" v-else>
              {{
                $i18n.locale === "ar"
                  ? data.description_ar
                  : data.description_en
              }}
            </h4>
          </div>
        </div>
        <div class="row row-cols-auto w-100 p-3 my-3" v-if="page_type == 2">
          <div class="col-12" v-if="photos.length > 0">
            <div class="myimgs-container">
              <div class="my-img-container">
                <img
                  :src="$store.state.server_images + src_certificate"
                  alt=""
                  clsas="img-bg-news"
                  :style="{
                    height: 'fit-content',
                    width: ScreenWidth <= 1025 ? '250px' : '500px',
                  }"
                />
                <div class="show-hide" @click="openPopup2(selectedIndex2)">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="30"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fill="white"
                      d="M16 0H9.5L12 2.5l-3 3L10.5 7l3-3L16 6.5zm0 16V9.5L13.5 12l-3-3L9 10.5l3 3L9.5 16zM0 16h6.5L4 13.5l3-3L5.5 9l-3 3L0 9.5zM0 0v6.5L2.5 4l3 3L7 5.5l-3-3L6.5 0z"
                    />
                  </svg>
                </div>
              </div>
              <!-- img changer -->
              <div class="grid-3">
                <img
                  class="imgs"
                  v-for="(item, index) in photos"
                  :key="index"
                  :src="$store.state.server_images + item.image"
                  alt=""
                  clsas="img-bg-news"
                  @click="
                    src_certificate = item.image;
                    openPopup2(index);
                  "
                />
              </div>
            </div>
          </div>
        </div>
        <div class="row row-cols-auto w-100 p-3 my-3" v-if="page_type == 1">
          <div class="col-12 my-3" v-for="(item, index) in excel" :key="index">
            <a
              class="btn btn-outline-dark w-100 py-4"
              @click.prevent="downloadFile(item.image)"
            >
              {{
                $i18n.locale === "ar"
                  ? "تحميل " + item.name_ar
                  : "Download " + item.name_en
              }}
            </a>
          </div>
        </div>
        <div class="row row-cols-auto w-100 p-3 my-5" v-if="page_type == 3">
          <div class="col-12 text-dark my-5"><h1>قادم قريباً...</h1></div>
        </div>
        <h3 v-if="page_type == 0" class="mt-5" style="color: #c39a3e">
          {{ $t("AvailablePlans") }}
        </h3>
        <div class="w-100" v-if="page_type == 0 && plans.length > 0">
          <!-- plans -->
          <div
            class="container hidden"
            v-in-view="'animate__fadeInUp'"
            v-if="Object.keys(plans).length > 0"
          >
            <div class="sections" v-if="Object.keys(plans).length > 0"></div>
            <div class="my-5" v-if="Object.keys(plans).length > 0">
              <swiper
                :modules="modules"
                slides-per-view="1"
                :space-between="35"
                data-swiper-autoplay="10000"
                autoplay
                navigation
                :pagination="{ clickable: true }"
                @swiper="onSwiper"
                @slideChange="onSlideChange"
              >
                <swiper-slide
                  v-for="(item, index) in plans"
                  :key="index"
                  style="cursor: pointer"
                  @click="openPopup3(index)"
                >
                  <div class="image-overlay">
                    <img
                      class="swiper-image"
                      :src="$store.state.server_images + item.image"
                      alt=""
                    />
                    <div class="overlay" style="cursor: pointer">
                      <div class="mt-5">
                        {{
                          $i18n.locale === "ar"
                            ? item.bedrooms_ar
                            : item.bedrooms_en
                        }}
                      </div>
                      <div>
                        {{
                          $i18n.locale === "ar" ? item.space_ar : item.space_en
                        }}
                      </div>
                    </div>
                  </div>
                </swiper-slide>
              </swiper>

              <!-- dividor -->
              <div
                class="dividor"
                v-if="index < Object.keys(data).length - 1"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="popup" id="popup" style="opacity: 0; display: none">
      <span class="close" @click="ShowHide()">X</span>
      <div class="popup-content">
        <swiper
          ref="mySwiper"
          :modules="modules"
          slides-per-view="1"
          :initial-slide="selectedIndex"
          :space-between="35"
          data-swiper-autoplay="10000"
          navigation
          :pagination="{ clickable: true }"
          @swiper="onSwiper"
          @slideChange="onSlideChange"
        >
          <swiper-slide key="0" style="cursor: pointer">
            <img :src="$store.state.server_images + data.image" alt="" />
          </swiper-slide>
          <swiper-slide
            v-for="(item, index) in data.images"
            :key="parseInt(index) + 1"
            style="cursor: pointer"
          >
            <img :src="$store.state.server_images + item.image" alt="" />
          </swiper-slide>
        </swiper>
      </div>
    </div>
    <div class="popup" id="popup2" style="opacity: 0; display: none">
      <span class="close" @click="ShowHide2()">X</span>
      <div class="popup-content">
        <swiper
          ref="mySwiper2"
          :modules="modules"
          slides-per-view="1"
          :initial-slide="selectedIndex2"
          :space-between="35"
          data-swiper-autoplay="10000"
          navigation
          :pagination="{ clickable: true }"
          @swiper="onSwiper"
          @slideChange="onSlideChange"
        >
          <swiper-slide
            v-for="(item, index) in photos"
            :key="index"
            style="cursor: pointer"
          >
            <img :src="$store.state.server_images + item.image" alt="" />
          </swiper-slide>
        </swiper>
      </div>
    </div>
    <div class="popup" id="popup3" style="opacity: 0; display: none">
      <span class="close" @click="ShowHide3()">X</span>
      <div class="popup-content">
        <swiper
          ref="mySwiper3"
          :modules="modules"
          slides-per-view="1"
          :initial-slide="selectedIndex3"
          :space-between="35"
          data-swiper-autoplay="10000"
          navigation
          :pagination="{ clickable: true }"
          @swiper="onSwiper"
          @slideChange="onSlideChange"
        >
          <swiper-slide
            v-for="(item, index) in plans"
            :key="index"
            style="cursor: pointer"
          >
            <img :src="$store.state.server_images + item.image" alt="" />
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store";
import axios from "axios";
import { Icon } from "@iconify/vue";
import { Navigation, Pagination, A11y, Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export default {
  name: "project-info",
  data() {
    return {
      type: "photo",
      src: null,
      src_certificate: null,
      videoSrc: null,
      data: {},
      old_data: {},
      page_type: 0,
      excel: [],
      photos: [],
      plans: [],
      services: [],
      type_arr: [],
      description_ar: [],
      description_en: [],
      ScreenWidth: screen.width,
      selectedIndex: 0,
      selectedIndex2: 0,
      selectedIndex3: 0,
    };
  },
  mounted() {
    this.getData();
  },
  directives: {
    inView: {
      mounted(el, binding) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                el.classList.add("animate__animated", binding.value);
                el.classList.remove("hidden");
                observer.unobserve(el); // Stop observing
              }
            });
          },
          { threshold: 0.1 } // Trigger when 10% of the element is visible
        );
        observer.observe(el);
      },
    },
  },
  components: {
    Icon,
    Swiper,
    SwiperSlide,
  },
  setup() {
    var x;
    const onSwiper = (swiper) => {
      x = swiper;
      swiper = x;
    };
    const onSlideChange = () => {
      x;
    };
    return {
      onSwiper,
      onSlideChange,
      modules: [Navigation, Pagination, A11y, Autoplay],
    };
  },
  methods: {
    async downloadFile(fileUrl) {
      try {
        const response = await fetch(this.$store.state.server_images + fileUrl);

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const blob = await response.blob();
        const link = document.createElement("a");
        const objectURL = URL.createObjectURL(blob);
        link.href = objectURL;

        // Extract the filename safely
        const url = new URL(fileUrl, window.location.origin);
        const fileName = url.pathname.split("/").pop();
        link.setAttribute("download", fileName || "download");

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Clean up memory
        URL.revokeObjectURL(objectURL);
      } catch (error) {
        console.error("Download failed:", error);
      }
    },
    async ChangeVideo(src) {
      window.localStorage.setItem("video", src);
      location.reload();
    },
    async GetVideo() {
      this.videoSrc = window.localStorage.getItem("video");
      this.type = "video";
      localStorage.removeItem("video");
    },
    openPopup(index) {
      this.selectedIndex = index;
      this.ShowHide();
      this.$nextTick(() => {
        if (this.$refs.mySwiper) {
          this.$refs.mySwiper.$el.swiper.slideTo(index);
        }
      });
    },
    ShowHide() {
      const element = document.getElementById("popup");
      if (element.style.opacity == 0 || element.style.opacity === "") {
        element.style.opacity = 1;
        element.style.display = "block";
      } else {
        element.style.opacity = 0;
        element.style.display = "none";
      }
    },
    openPopup2(index) {
      this.selectedIndex2 = index;
      this.ShowHide2();
      this.$nextTick(() => {
        if (this.$refs.mySwiper2) {
          this.$refs.mySwiper2.$el.swiper.slideTo(index);
        }
      });
    },
    ShowHide2() {
      const element = document.getElementById("popup2");
      if (element.style.opacity == 0 || element.style.opacity === "") {
        element.style.opacity = 1;
        element.style.display = "block";
      } else {
        element.style.opacity = 0;
        element.style.display = "none";
      }
    },
    openPopup3(index) {
      this.selectedIndex3 = index;
      this.ShowHide3();
      this.$nextTick(() => {
        if (this.$refs.mySwiper3) {
          this.$refs.mySwiper3.$el.swiper.slideTo(index);
        }
      });
    },
    ShowHide3() {
      const element = document.getElementById("popup3");
      if (element.style.opacity == 0 || element.style.opacity === "") {
        element.style.opacity = 1;
        element.style.display = "block";
      } else {
        element.style.opacity = 0;
        element.style.display = "none";
      }
    },
    hideLoadingScreen() {
      store.commit("hideLoadingScreen");
    },
    getData() {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const id = urlParams.get("id");
      axios
        .get(store.state.server + "get-project-id/" + id)
        .then((response) => {
          this.data = response.data;
          this.type_arr = this.data.type;
          this.src = this.data.image;
          if (this.data.certificates) {
            this.photos = this.data.certificates;
          }
          try {
            this.description_ar = JSON.parse(response.data.description_ar);
            this.description_en = JSON.parse(response.data.description_en);
          } catch {
            console.log("Only one desc");
          }
          if (Object.keys(this.photos).length > 0) {
            this.src_certificate = this.photos[0].image;
          }
          let plans_pr = this.data.plans;
          for (let key in plans_pr) {
            this.plans.push(plans_pr[key].plan);
          }
          this.excel = this.data.payments;
          let services_pr = this.data.services;
          for (let key in services_pr) {
            this.services.push(services_pr[key].service);
          }
          this.hideLoadingScreen();
          if (window.localStorage.getItem("video")) {
            this.GetVideo();
          } else {
            let videos = this.data.videos;
            if (videos.length > 0) this.videoSrc = this.data.videos[0].video;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
/* General Grid Styles */
.grid-2 {
  display: grid;
  grid-template-columns: auto auto;
}

.photos-videos {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.abs-buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  background-color: whitesmoke;
  padding: 10px 30px;
  border: 1px solid rgba(0, 0, 0, 0.5);
  border-radius: 15px;
}

.btn-style {
  margin: 0px 10px;
  cursor: pointer;
}

.my-img-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 70px;
}

.myvideo-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 70px;
}

.my-video {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  width: 500px;
  height: 300px;
  background-color: black;
}

.grid-3 {
  display: grid;
  grid-template-columns: auto auto auto;
  justify-content: center;
  align-items: center;
}

.imgs {
  height: 100px;
  width: 100px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  margin: 30px 20px 0;
  cursor: pointer;
  transition: transform 0.5s ease-in-out, box-shadow 0.5s ease-in-out;
}

.video-card {
  height: 100px;
  width: 100px;
  background-color: black;
  margin: 30px 20px 0;
  cursor: pointer;
  transition: transform 0.5s ease-in-out, box-shadow 0.5s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
}

.imgs:hover {
  transform: translateY(-10px);
  box-shadow: 10px 10px 5px 0px rgba(0, 0, 0, 0.75);
}

.video-card:hover {
  transform: translateY(-10px);
  box-shadow: 10px 10px 5px 0px rgba(0, 0, 0, 0.75);
}

.content {
  width: 500px;
}

.content > h1 {
  color: #c39a3e;
}

.popup {
  position: fixed;
  z-index: 10000000;
  top: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 0.181);
  backdrop-filter: blur(4px);
  width: 100%;
  height: 100%;
  overflow-y: hidden;
}

.popup-content {
  margin-top: 30px;
  position: relative;
  width: 100%;
  height: 90%;
}

.popup-content img {
  height: 600px;
  width: auto;
}

.show-hide {
  position: absolute;
  top: 10px;
  left: 10px;
  background-color: rgba(195, 194, 194, 0.5);
  padding: 10px;
  cursor: pointer;
}

.close {
  position: fixed;
  z-index: 101;
  top: 10px;
  left: 5px;
  height: 60px;
  width: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 30px;
  margin-top: 20px;
  margin-left: 20px;
  padding: 10px;
  text-align: center;
  background-color: gray;
  color: white;
  cursor: pointer;
  border-radius: 50%;
}

/* Responsive Styles */
@media screen and (max-width: 1025px) {
  .grid-3 {
    grid-template-columns: auto auto;
  }

  .grid-2 {
    grid-template-columns: auto;
  }

  .my-video {
    width: 300px;
    height: auto;
  }

  .popup-content img {
    margin-top: 200px;
    height: auto;
    width: 300px;
  }
}

/* Vendor Prefixes for Compatibility */
.abs-buttons {
  -webkit-border-radius: 15px;
  -moz-border-radius: 15px;
  border-radius: 15px;
}

.imgs,
.video-card {
  -webkit-transition: transform 0.5s ease-in-out, box-shadow 0.5s ease-in-out;
  -moz-transition: transform 0.5s ease-in-out, box-shadow 0.5s ease-in-out;
  -o-transition: transform 0.5s ease-in-out, box-shadow 0.5s ease-in-out;
  transition: transform 0.5s ease-in-out, box-shadow 0.5s ease-in-out;
}

.imgs:hover,
.video-card:hover {
  -webkit-transform: translateY(-10px);
  -moz-transform: translateY(-10px);
  -o-transform: translateY(-10px);
  transform: translateY(-10px);
  -webkit-box-shadow: 10px 10px 5px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 10px 10px 5px 0px rgba(0, 0, 0, 0.75);
  box-shadow: 10px 10px 5px 0px rgba(0, 0, 0, 0.75);
}

.popup {
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(4px);
}
</style>
